import styled from 'styled-components';
import { Textarea } from '@libs/uikit/Components';

export const TagTextarea = styled(Textarea)`
    height: 500px;
    cursor: unset;

    &:hover {
        border-radius: 2px;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(209, 214, 217);
    }
    &:focus {
        border-radius: 2px;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(209, 214, 217);
    }
`;
